<template>
  <v-container>
    <v-flex xs12 sm12>
      <div>
        <v-card>
          <v-card-title>
            Agenda todos los responsables
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="quotes"
            :search="search"
            :loading="loadingTable"
          >

            <template slot="items" slot-scope="props"  v-show="assemblies.status==0"
            >
              <td class="text-xs-center">{{ props.item.schedule_start_date  }}</td>
              <td class="text-xs-center">{{ props.item.schedule_start_time | formatHour }}</td>
              <td class="text-xs-center">{{ props.item.schedule_end_date }}</td>
              <td class="text-xs-center">{{ props.item.schedule_end_time | formatHour }}</td>
              <td class="text-xs-center">{{ props.item.nameResponsible}}</td>
              <td class="text-xs-center">{{ props.item.signatureurl }}</td>
              <td class="text-xs-center" v-if="props.item.status==0">Sin tomar</td>
              <td class="text-xs-center" v-else-if="props.item.status==1">Tomada</td>
              <td class="text-xs-center" v-else-if="props.item.status==3">Cerrada</td>
              <td class="text-xs-center">
                <v-tooltip top>
                  <v-icon
                    medium
                    class="mr-2"
                    @click="setDate(props.item)"
                    slot="activator"
                  >
                    zoom_in
                  </v-icon>
                  <span>Ir a cita</span>

                </v-tooltip>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </v-card>
      </div>
    </v-flex>

    <v-flex xs12 sm12>
      <v-card>
        <v-flex
          sm12
          lg3
          class="pa-3 mb-3 feature-pane"
        >
          <v-btn
            fab
            outline
            small
            absolute
            left
            color="primary"
            @click="nextPrev(-1)"
          >
            <v-icon dark>
              keyboard_arrow_left
            </v-icon>
          </v-btn>

          <v-btn
            fab
            outline
            small
            absolute
            right
            color="primary"
            @click="nextPrev(1)"
          >
            <v-icon
              dark
            >
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-flex>
        <v-layout mb-3 justify-center row>
          <v-flex pb-4 xs2>
            <span class="headline primary--text">{{ month_to_show }}</span>
          </v-flex>
        </v-layout>
        <v-sheet height="auto">
          <v-calendar
            :now="start"
            :end="start"
            :start="start"
            ref="calendar"
            color="primary"
          >
            <template v-slot:day="{ date }">
              <template v-for="event in eventsMap[date]">
                <v-menu
                  :key="event.id"
                  v-model="event.open"
                  full-width
                  offset-x
                >
                  <template v-slot:activator="{ on }">
                    <div
                      v-if="!event.time"
                      v-ripple
                      v-bind:class="[events.status ==0 ? my-event : '', my-event-green]"
                      class="my-event"
                      v-on="on"
                      v-html="event.title"
                    ></div>
                  </template>
                  <v-card
                    color="grey lighten-4"
                    min-width="350px"
                    flat
                  >
                    <v-toolbar
                      color="primary"
                      dark
                    >
                      <v-toolbar-title v-html="event.title"></v-toolbar-title>
                    </v-toolbar>
                    <v-card-title primary-title>
                      <span v-html="event.details"></span>
                    </v-card-title>
                    <v-card-text>
                      <span v-html="date_init + event.start"></span>
                      <br>
                      <span v-html="date_end + event.end"></span>
                      <br>
                      <span v-html="taker + (event.taker != null ? event.name: '')"></span>

                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        flat
                        color="secondary"
                      >
                        Cancel
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </template>
            </template>
          </v-calendar>
        </v-sheet>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
    import axios from 'axios'
     import formatHour from "../../libs/filter"
    export default {
        name: "reportQuote",
        data:()=>({
            taker: 'Tomador: ',
            start: '',
            start: '',
            date_init: 'Hora inicial: ',
            date_end: 'Hora final: ',
            today: Date.now(),
            events: [],
            headers: [
                { text: 'Fecha inicio', align: 'center', value: 'schedule_start_date' },
                { text: 'Hora inicio', align: 'center', value: 'schedule_start_time' },
                { text: 'Fecha fin', align: 'center', value: 'schedule_end_date' },
                { text: 'Hora fin', align: 'center', value: 'schedule_end_time' },
                { text: 'Responsable', align: 'center', value: 'nameResponsible' },
                { text: 'Firma', align: 'center', value: 'signatureurl' },
                { text: 'Estado', align: 'center', value: 'status' },
                { text: 'Acción', align: 'center', value: 'id', sortable: false }
            ],
            search: '',
            quotes: [],
            loadingTable: false,
            monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
              "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
            ],
            month_to_show: '',

        }),
        watch: {
          start(newValue) {
            const month = newValue.split('-')
            if (month.length > 2) {
              const montNumber = parseInt(month[1], 10)
              this.month_to_show = this.monthNames[montNumber-1]
              return
            }
            this.month_to_show = ''
          }
        },
        methods: {
            getDay () {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0!

                var yyyy = today.getFullYear();

                this.start =  yyyy + '-' + mm + '-' + dd;
            },
            nextPrev (num) {
                // let date = '2019-06-06'
                let fecha_split = this.start.split('-');
                let month = (parseInt(fecha_split[1]) + num)
                let nueva_fecha = fecha_split[0] + "-" + month + "-" + fecha_split[2];
                this.start = nueva_fecha;
                //this.start = this.start.setMonth(this.start.getMonth() + 3)
            },
            getData () {
                axios.get('/api/quores/responsable/report')
                    .then(resp=>{
                        this.quotes = resp.data.data
                    this.events = [];
                    this.events = resp.data.data.map(obj=>{
                        return {
                            id: obj.id,
                            is_external: obj.is_external,
                            date: obj.schedule_start_date,
                            open: false,
                            title: obj.description,
                            details: '',
                            start: formatHour(obj.schedule_start_time),
                            end: formatHour(obj.schedule_end_time),
                            status: obj.status,
                            taker: obj.name
                        }
                    })

                    })
            },
            setDate (item) {
                this.start = item.schedule_start_date
            },
            dateAll() {
                this.getDay();
                axios.get('/api/schedule/show').then(resp=>{
                    console.log(resp.data)
                    this.other = resp.data.other
                    this.events = [];
                    this.events = resp.data.data.map(obj=>{
                        return {
                            id: obj.id,
                            is_external: obj.is_external,
                            date: obj.schedule_start_date,
                            open: false,
                            title: obj.description,
                            details: '',
                            start: formatHour(obj.schedule_start_time),
                            end: formatHour(obj.schedule_end_time),
                            status: obj.status,
                            taker: obj.name
                        }
                    })

                });
            },
        },
        mounted() {
            this.getData()
            //this.dateAll()
        },
        computed: {
            // convert the list of events into a map of lists keyed by date
            eventsMap () {
                const map = {}
                this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
                return map
            }
        },
    }
</script>

<style lang='scss'>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
  .my-event-green {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #71c066;
    color: #ffffff;
    border: 1px solid #71c066;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/quotes/reportQuoteAll.vue